import { TextField } from '@mui/material';
import React from 'react';
import type { FilterField } from '../../../api/models/filters.model';

interface NumberRangeFilterFieldProps {
	field: FilterField;
	minValue: string;
	maxValue: string;
	onMinChange: (val: string) => void;
	onMaxChange: (val: string) => void;
}

const NumberRangeFilterField: React.FC<NumberRangeFilterFieldProps> = ({
	field,
	minValue,
	maxValue,
	onMinChange,
	onMaxChange,
}) => {
	const minError =
		minValue !== undefined && minValue !== '' && Number(minValue) < Number(field.min);
	const maxError =
		maxValue !== undefined && maxValue !== '' && Number(maxValue) > Number(field.max);
	return (
		<>
			<TextField
				fullWidth
				margin="normal"
				size="small"
				label={`${field.label} (Min)`}
				type="number"
				placeholder={String(field.min)}
				value={minValue || ''}
				onChange={(e) => onMinChange(e.target.value)}
				error={minError}
				helperText={minError ? `Minimum value is ${field.min}` : ''}
			/>
			<TextField
				fullWidth
				margin="normal"
				size="small"
				label={`${field.label} (Max)`}
				type="number"
				placeholder={String(field.max)}
				value={maxValue || ''}
				onChange={(e) => onMaxChange(e.target.value)}
				error={maxError}
				helperText={maxError ? `Maximum value is ${field.max}` : ''}
			/>
		</>
	);
};

export default NumberRangeFilterField;
